import { get } from "api/apiBridges/httpBridge";

export const AddWorker = {
    id: 'addWorker',
    api: 'defBridge',
    title: 'Добавление',
    tabs: ['worker'],
    defaultTab: 'worker',
    
  };

  export const EditWorker = {
    id: 'editWorker',
    api: 'defBridge',
    title: 'Редактирование',
    tabs: ['worker'],
    defaultTab: "worker",
  };

  export const Roles = {
    id: 'roles',
    api: 'defBridge',
    title: 'Роли',
    tabs: ['roles'],
    defaultTab: 'roles',
    rules: [
      {id: "main.new_clients", title: "Основное - Новые клиенты"},
      {id: "main.my_clients", title: "Основное - Мои клиенты"},
      {id: "main.pick_product", title: "Основное - Забор товара"},
      {id: "main.move_product", title: "Основное - Движение товара"},
      {id: "main.storage_product", title: "Основное - Хранение товара"},
      {id: "main.shipment_product", title: "Основное - Отгрузка"},
      {id: "main.addr_storage", title: "Основное - Адресное хранение"},
      {id: "main.change_columns", title: "Основное - Редактирование воронок"},
      {id: "deal.pick_product", title: "Шторка сделки - Забор товара"},
      {id: "deal.acceptance", title: "Шторка сделки - Приемка"},
      {id: "deal.sort", title: "Шторка сделки - Сортировка"},
      {id: "deal.package", title: "Шторка сделки - Упаковка"},
      {id: "deal.logistic", title: "Шторка сделки - Логистика"},
      {id: "deal.pricing", title: "Шторка сделки - Финансы"},
      {id: "deal.inner.linker", title: "Сделка - Привязка"},
      {id: "deal.inner.pay", title: "Сделка - Оплата"},
      {id: "settings.company", title: "Настройки - Компания"},
      {id: "settings.handbook", title: "Настройки - Справочник"},
      {id: "company.change_roles", title: "Компания - Изменение ролей"},
      {id: "company.change_workers", title: "Компания - Редактирование сотрудников"},
      {id: "company.show_login", title: "Компания - отображение логина сотрудника"},
    ]
  };
